// extracted by mini-css-extract-plugin
export default {"container":"description_container__ONHJ9"};